module.exports = __webpack_public_path__ + "static/media/slovak_infantry_120.f0467ca0.png";